import styled from "styled-components";

export const SectionContainer = styled.section`
  padding: 80px 0;
  background-color: #fff;
  text-align: center;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const CardsFlexContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
  max-width: 1320px;
  margin: 0 auto;
`;

export const CardWrapper = styled.div`
  flex: 0 0 442px;
  max-width: 442px;
  box-sizing: border-box;
  @media (max-width: 768px) {
    flex: 1;
  }
`;
